import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { DialogService } from '../dialog.service';
import { StorageService } from '../storage.service';
import { RouterService } from '../router.service';

@Injectable()
export class AutoLogoutInterceptor implements HttpInterceptor {
    constructor(
        private dialog: DialogService,
        private storage: StorageService,
        private router: RouterService,
    ) {
    }

    public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const httpEventObservable = new Observable<HttpEvent<any>>((observer) => {
            this.try(req, next, observer);
        });

        return httpEventObservable;
    }

    private async try(
        req: HttpRequest<any>,
        next: HttpHandler,
        httpEventObserver: Observer<HttpEvent<any>>
    ): Promise<void> {
        try {
            const event = await next.handle(req).toPromise();
            // console.log(event);
            httpEventObserver.next(event);
            httpEventObserver.complete();
        } catch (e) {
            console.log(e, e.status);
            if (e instanceof HttpErrorResponse && e.status === 403) {

                const alert = this.dialog.alert({
                    title: 'Keine gültige Session',
                    subTitle: 'Bitte erneut anmelden',
                    text: 'Ihre Session ist ungültig oder bereits abgelaufen<br>Bitte melden Sie sich erneut an.',
                    buttons: [{
                        name: 'Ok',
                        type: 'flat',
                        handler: () => {
                            location.href = '/';
                            alert.close();
                        }
                    }]
                });
                await this.storage.clear();
                httpEventObserver.error(e);
            } else {
                httpEventObserver.error(e);
                httpEventObserver.complete();
            }
        }
    }

}
